
class FBAccount {
  lifetime = 7 * 24 * 60 * 60;

  constructor() {
    FB.init({
      appId: '289407448320697',
      cookie: true,
      status: true,
      xfbml: true,
      version: 'v11.0'
    });
    FB.AppEvents.logPageView();
  }


  tryToLogin() {
    FB.getLoginStatus((res) => {
      if (res.status !== 'connected') return;
      if (this.isUserLoggedIn()) return;
      
      this.loginUser(res.authResponse.accessToken, res.authResponse.userID);
    });
  }

  isUserLoggedIn() {
    return `; ${document.cookie};`.indexOf("; userAuthToken=") !== -1;
  }

  loginUser(accessToken, userId) {
    $.ajax({
      method: 'POST',
      url: '/authenticate',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        userId: userId,
        accessToken: accessToken
      })
    })
    .done((res) => {
      this.setUser(res.data);
      window.location.href = '/';
    })
    .fail((jqXHR) => {
      this.handleError(jqXHR.responseText, accessToken, userId);
    });
  }

  setUser(data) {
    document.cookie = `userAuthToken=${data.token};max-age=${this.lifetime};path=/`;
  }

  handleError(status, accessToken, userId) {
    switch(status) {
      case 'STANDARD_USER_ACCOUNT':
        const search = '?message=fb-standard-account';
        if (window.location.pathname === '/logowanie' && window.location.search === search) return;
        window.location.href = '/logowanie' + search;
        return;
      
      case 'USER_NOT_EXISTS':
        this.registerUser(accessToken, userId);
        return;

      default:
        console.log('unhandled error', status);
        //window.location.href = '/logowanie';
    }
  }

  registerUser(accessToken, userId) {
    $.ajax({
      method: 'POST',
      url: '/fb-register',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        userId: userId,
        accessToken: accessToken
      })
    })
    .done((res) => {
      console.log('res', res)
      if (res.success) {
        window.location.href = '/rejestracja-podsumowanie';
      } else {
        console.error('error', res.error);
      }
    })
    .fail((jqXHR) => {
      console.error(jqXHR)
    });
  }
}

(function(d, s, id){
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {return;}
  js = d.createElement(s); js.id = id;
  js.src = "https://connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

let fBAccount;

if (window.FB) {
  fBAccount = new FBAccount();
} else {
  window.fbAsyncInit = () => {
    fBAccount = new FBAccount();
  };
}


function checkLoginState() {
  if (fBAccount) {
    fBAccount.tryToLogin();
  }
}